import React from 'react';

const LayoutContainer = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default LayoutContainer;
